import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'
import _ from 'lodash'
import { arrayMove } from '../../util'

// Constants
export const constants = {
  SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS: createSagaAction(
    'SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS'
  ),
  SCHEDULED_DELIVERIES_ADD: createSagaAction('SCHEDULED_DELIVERIES_ADD'),
  SCHEDULED_DELIVERIES_FETCH: createSagaAction('SCHEDULED_DELIVERIES_FETCH'),
  SCHEDULED_DELIVERIES_FETCH_BY_ID: createSagaAction('SCHEDULED_DELIVERIES_FETCH_BY_ID'),
  SCHEDULED_DELIVERIES_UPDATE: createSagaAction('SCHEDULED_DELIVERIES_UPDATE'),
  SCHEDULED_DELIVERIES_DELETE: createSagaAction('SCHEDULED_DELIVERIES_DELETE'),
  SCHEDULED_DELIVERIES_ITEM_UP: createSagaAction('SCHEDULED_DELIVERIES_ITEM_UP'),
  SCHEDULED_DELIVERIES_ITEM_DOWN: createSagaAction('SCHEDULED_DELIVERIES_ITEM_DOWN'),
  SCHEDULED_DELIVERIES_ITEM_DELETE: createSagaAction('SCHEDULED_DELIVERIES_ITEM_DELETE')
}

// Action Creators
export const actions = {
  fetchOpenRequests: () => ({
    type: constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.ACTION
  }),
  addScheduledDelivery: ({ scheduledDate, vehicle, driver, arrayOpenItems, userId }) => ({
    type: constants.SCHEDULED_DELIVERIES_ADD.ACTION,
    scheduledDate,
    vehicle,
    driver,
    arrayOpenItems
  }),
  fetchScheduledDeliveries: () => ({
    type: constants.SCHEDULED_DELIVERIES_FETCH.ACTION
  }),
  fetchScheduledDeliveryById: scheduledDeliveryId => ({
    type: constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.ACTION,
    scheduledDeliveryId
  }),
  updateScheduledDelivery: ({ scheduledDeliveryId, scheduledDeliveryDetails, items }) => ({
    type: constants.SCHEDULED_DELIVERIES_UPDATE.ACTION,
    scheduledDeliveryId,
    scheduledDeliveryDetails,
    items
  }),
  deleteScheduledDelivery: scheduledDeliveryId => ({
    type: constants.SCHEDULED_DELIVERIES_DELETE.ACTION,
    scheduledDeliveryId
  }),
  itemUp: item => ({
    type: constants.SCHEDULED_DELIVERIES_ITEM_UP.ACTION,
    item
  }),
  itemDown: item => ({
    type: constants.SCHEDULED_DELIVERIES_ITEM_DOWN.ACTION,
    item
  }),
  itemDelete: item => ({
    type: constants.SCHEDULED_DELIVERIES_ITEM_DELETE.ACTION,
    item
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, { type, payload, item }) => {
  switch (type) {
    case constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.ACTION:
      return { ...state, ...{ loading: true } }
    case constants.SCHEDULED_DELIVERIES_FETCH_OPEN_REQUESTS.SUCCESS:
      return { ...state, ...{ openRequests: payload.data, loading: false } }
    case constants.SCHEDULED_DELIVERIES_FETCH.ACTION:
      return { ...state, ...{ loading: true } }
    case constants.SCHEDULED_DELIVERIES_FETCH.SUCCESS:
      return { ...state, ...{ scheduledDeliveries: payload.data, loading: false } }
    case constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.ACTION:
      return { ...state, ...{ loading: true } }
    case constants.SCHEDULED_DELIVERIES_FETCH_BY_ID.SUCCESS:
      return { ...state, ...{ scheduledDelivery: payload.data, loading: false } }
    case constants.SCHEDULED_DELIVERIES_UPDATE.ACTION:
      return { ...state, ...{ loading: true } }
    case constants.SCHEDULED_DELIVERIES_UPDATE.SUCCESS:
      return { ...state, ...{ loading: false } }
    case constants.SCHEDULED_DELIVERIES_UPDATE.FAILED:
      return { ...state, ...{ loading: false } }

    case constants.SCHEDULED_DELIVERIES_ITEM_UP.ACTION: {
      const { scheduledDelivery } = state

      // get the current index
      const itemCurrentIndex = _.findIndex(scheduledDelivery.items, itemI => itemI.id === item.key)

      arrayMove(scheduledDelivery.items, itemCurrentIndex, itemCurrentIndex - 1)

      return { ...state }
    }
    case constants.SCHEDULED_DELIVERIES_ITEM_DOWN.ACTION: {
      const { scheduledDelivery } = state

      // get the current index
      const itemCurrentIndex = _.findIndex(scheduledDelivery.items, itemI => itemI.id === item.key)

      arrayMove(scheduledDelivery.items, itemCurrentIndex, itemCurrentIndex + 1)

      return { ...state }
    }

    case constants.SCHEDULED_DELIVERIES_ITEM_DELETE.ACTION: {
      const { scheduledDelivery } = state

      // get the current index
      const itemCurrentIndex = _.findIndex(scheduledDelivery.items, itemI => itemI.id === item.key)

      scheduledDelivery.items.splice(itemCurrentIndex, 1)

      return { ...state }
    }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/scheduledDeliveriesActions.js